import { useLayoutEffect } from 'react';
import { themeController } from './themeController';

// Mount once, above routes and portals. Reading the theme must never install listeners.
export default function ThemeApplication() {
  useLayoutEffect(() => themeController.start(), []);
  return null;
}
